import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Announcements from "./components/Announcements";
import Statements from "./components/Statements";
import Dynamics from "./components/Dynamics";
import FeatureFlow from "./components/FeatureFlow";
import Channels from "./components/Channels";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-background-50">
        <Hero />
        <Announcements />
        <Statements />
        <Dynamics />
        <FeatureFlow />
        <Channels />
        <Faq />
      </main>
      <Footer />
    </>
  );
}